import { EnumBase } from 'hay-core-react';
class UsuarioTransacaoStatusEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.usuariotransacao.status.pendente',
                'main.usuariotransacao.status.pago',
                'main.usuariotransacao.status.expirada',
                'main.usuariotransacao.status.rejeitada',
            ],
            'main.usuariotransacao.status.pendente'
        );
    }
}

const instance = new UsuarioTransacaoStatusEnum();
export default instance;
